import React from 'react';
import {useRef, useEffect, useState} from 'react';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSignal, faComputer, faMobileRetro, faSatelliteDish, faBell } from '@fortawesome/free-solid-svg-icons';

// User Defined modules and style sheets
import NotificationItem from './notificationItem/notificationItem';
// import './notificationsPage.css';

function NotificationsPage() {
    const [notifications, setNotifications] = useState('');
    const [cards, setCards] = useState('');

    const generateNotifications = async () => {
        const arrayOfNotifs = [];
        notifications.map(notification => {
            const notif = React.createElement(NotificationItem, {notification});
            arrayOfNotifs.push(notif);
        });
        setCards(arrayOfNotifs);
    }

    useEffect(() => {
        const getCookie = (name) => {
            const match = document.cookie
              .split("; ")
              .find((row) => row.startsWith(name + "="));
          
            if (!match) return null; // Return null if cookie not found
      
            try {
              const rawValue = match.split("=")[1];
            //   console.log(`Raw cookie value for ${name}:`, rawValue);
              return decodeURIComponent(rawValue); // Properly decode it
            } catch (error) {
              console.error(`Error decoding cookie ${name}:`, error);
              return null; // Return null if decoding fails
            }
        }

        async function getNotifications() {
            try {
                const cookie = document.cookie;
                const email = cookie.split(";")[2].split("=")[1];
                const loginToken = getCookie('data');
                // console.log(loginToken);
                const getData = await axios({
                    url: `${import.meta.env.VITE_DEVBACKENDPATH}:${import.meta.env.VITE_BACKENDPORT}/api/notification/fetchall`, 
                    method: 'POST',
                    /*headers: {
                        contentType: "application/json",
                        connection: "keep-alive"
                    },*/
                    data: {
                        loginToken: loginToken,
                        email: email
                    }
                });
                console.log(getData);
                if(getData.data.length < 1){
                    // setNotifications({});
                    return;
                }
                // console.log(getNotifications.data.data);
                // setNotifications(getNotifications.data.data);

                const notifications = [];
                let count = 0;

                getData.data.data.map(notification => {
                    const notif = React.createElement(NotificationItem, {key: count, data: notification});
                    notifications.push(notif);
                    count ++;
                });
                setCards(notifications);
                // return response.json();
            } catch (err) {
                console.log(err);
            }
        }
        getNotifications();
    }, []);

    return(
        <>
        <div className='spacer'></div>
        <div className='spacer'></div>
        <article className='flex column justify-content-cntr align-items-cntr bg-color-background color-foreground'>
            <div className='flex row flex-nowrap justify-content-cntr align-items-cntr margin-t-md'>
                <h1 className='h1'>Notifications</h1>
                <FontAwesomeIcon icon={faBell} className='font-lg margin-sm' />
            </div>
            <ul id='notificationList' className='border rounded overflow-y-scroll min-height-lg min-width-xxl' loading='lazy'>
                {cards}
            </ul>
        </article>
        <div className='spacer'></div>
        </>
    );

}

export default NotificationsPage;